import React from 'react';

import style from './Library.module.css';
import ChonkyFileBrowser from './Chonky/ChonkyFileBrowser';
import FolderContentManagerDropdown from './FolderContentManagerDropdown';
import {
	getContentManagersByAccount,
} from 'Vulture/Users';
import {
	isAdministrativeUser,
} from 'Vulture/Session';
import {
	isSystemFolder,
} from '../../../Util/ChonkyFileBrowserETL';

class LibraryView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			currentFolder:      null,
			allContentManagers: [],
		};
	}

	componentDidMount() {
		this.loadAllContentManagers();
	}

	loadAllContentManagers = async () => {
		const {
			accountUUID,
		} = this.props;

		try {
			const contentManagers = await getContentManagersByAccount(accountUUID);
			const contentManagerOptions = contentManagers.map((cm) => {
				return {
					value: cm.uuid,
					label: `${cm.last_name}, ${cm.first_name}`,
				};
			});

			this.setState({
				allContentManagers: contentManagerOptions,
			});
		} catch (error) {
			// Error loading content managers
			this.setState({
				allContentManagers: [],
			});
		}
	}

	handleCurrentFolderChange = (currentFolderId, fileMap) => {
		// currentFolderId format: "node_{id}" or "root"
		// Track the current folder the user is browsing

		// Don't show selector for root
		if (!currentFolderId || currentFolderId === 'root') {
			this.setState({
				currentFolder: null,
			});
			return;
		}

		// Check if it's a folder (starts with "node_")
		if (currentFolderId.toString().startsWith('node_')) {
			// Extract numeric ID from "node_{id}" format
			const idStr = currentFolderId.toString().replace(/^node_/, '');
			const folderId = parseInt(idStr, 10);

			// Get folder data from fileMap if available
			const folderData = fileMap && fileMap[currentFolderId];
			const folderName = folderData ? folderData.name : '';

			// Don't show selector for system folders (Stock Library, Account Library, All Uploads, per-account Uploads)
			const isSystem = isSystemFolder(folderData);

			if (!isNaN(folderId) && !isSystem && folderData) {
				// Extract parent ID if it's in "node_XXX" format
				let parentId = null;
				if (folderData.parent_id || folderData.parentId) {
					const parentStr = (folderData.parent_id || folderData.parentId).toString();
					if (parentStr.startsWith('node_')) {
						parentId = parseInt(parentStr.replace(/^node_/, ''), 10);
					} else {
						parentId = parseInt(parentStr, 10);
					}
				}

				// Pass the full folder data including parent_id for inheritance
				this.setState({
					currentFolder: {
						id:        folderId,
						name:      folderName,
						parent_id: parentId,
						parentId,
					},
				});
				return;
			}
		}

		// Invalid folder ID or root folder - clear
		this.setState({
			currentFolder: null,
		});
	}

	render() {
		const {
			app,
			accountUUID,
			permissions,
			isVCLEnabled,
		} = this.props;

		const {
			currentFolder,
			allContentManagers,
		} = this.state;

		return (
			<React.Fragment>
				<div className={`systems-page fade-in`}>
					<div className={style.pageHeader}>
						<h2>Library</h2>
						<div className={style.headerDetails}>
							<b>Image Format:</b> .JPEG, .JPG and .PNG (Max. 10MB). <b>Movie Format: </b>.MP4 as H.264, .WebM<br />
							(Max file size: 400MB, Max resolution: HD, Max Framerate: 30fps)
						</div>
					</div>
					<div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
						<ChonkyFileBrowser
							app={app}
							accountUUID={accountUUID}
							isVCLEnabled={isVCLEnabled}
							permissions={permissions}
							onCurrentFolderChange={this.handleCurrentFolderChange}
							{...(isAdministrativeUser() && currentFolder && {
								injectedHeaderDropdown:          allContentManagers,
								injectedHeaderDropdownComponent: (props) => {
									return (
										<FolderContentManagerDropdown
											key={`folder-${currentFolder.id}-${currentFolder.name}`}
											{...props}
											folder={currentFolder}
											accountUUID={accountUUID}
										/>
									);
								},
							})}
						/>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default LibraryView;